import Vue from 'vue'
import VueI18n from "vue-i18n";
import langTH from "@/lang/th";
import langEN from "@/lang/en";

Vue.use(VueI18n)
let timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

let localeLang = "th",
  messages = { th: langTH };
if (timeZone != "Asia/Bangkok") {
  localeLang = "en";
  messages = { en: langEN };
}
if (localStorage.getItem("lang")) {
  localeLang = localStorage.getItem("lang")
  messages = localStorage.getItem("lang") == 'th' ? { th: langTH } : { en: langEN };
}
const i18n = new VueI18n({
  localeLang,
  fallbackLocale: ["th", "en"],
  messages,
  silentTranslationWarn: true,
  locale: localeLang
});

export default i18n
